export default class PlayerDetailedPointsModel {
  public total: number = null;
  public minutesPlayed: number = null;
  public yellowCards: number = null;
  public redCards: number = null;
  public goals: number = null;
  public penaltyGoals: number = null;
  public ownGoals: number = null;
  public assists: number = null;
  public cleanSheets: number = null;
  public shots: number = null;
  public shotsOn: number = null;
  public offsides: number = null;
  public foulsCommitted: number = null;
  public penaltyCommitted: number = null;
  public penaltyWon: number = null;
  public penaltyMissed: number = null;
  public tackles: number = null;
  public concededGoals: number = null;
  public caughtBall: number = null;
  public saves: number = null;
}
